var items = {
  "block.minecraft.air": "паветра",
  "block.minecraft.stone": "камень",
  "block.minecraft.granite": "граніт",
  "block.minecraft.polished_granite": "паліраваны граніт",
  "block.minecraft.diorite": "дыярыт",
  "block.minecraft.polished_diorite": "паліраваны дыярыт",
  "block.minecraft.andesite": "андэзіт",
  "block.minecraft.polished_andesite": "паліраваны андэзіт",
  "block.minecraft.grass_block": "зямля з дзёрнам",
  "block.minecraft.dirt": "зямля",
  "block.minecraft.coarse_dirt": "грубая зямля",
  "block.minecraft.podzol": "падзол",
  "block.minecraft.crimson_nylium": "барвовы нілій",
  "block.minecraft.warped_nylium": "скажоны нілій",
  "block.minecraft.cobblestone": "бут",
  "block.minecraft.oak_planks": "дубовыя дошкі",
  "block.minecraft.spruce_planks": "яловыя дошкі",
  "block.minecraft.birch_planks": "бярозавыя дошкі",
  "block.minecraft.jungle_planks": "дошкі з трапічнай драўніны",
  "block.minecraft.acacia_planks": "дошкі з акацыі",
  "block.minecraft.dark_oak_planks": "дошкі з цёмнага дубу",
  "block.minecraft.crimson_planks": "барвовыя дошкі",
  "block.minecraft.warped_planks": "скажоныя дошкі",
  "block.minecraft.oak_sapling": "саджанец дуба",
  "block.minecraft.spruce_sapling": "саджанец елкі",
  "block.minecraft.birch_sapling": "саджанец бярозы",
  "block.minecraft.jungle_sapling": "саджанец трапічнага дрэва",
  "block.minecraft.acacia_sapling": "саджанец акацыі",
  "block.minecraft.dark_oak_sapling": "саджанец цёмнага дуба",
  "block.minecraft.bedrock": "карэнная парода",
  "block.minecraft.sand": "пясок",
  "block.minecraft.red_sand": "чырвоны пясок",
  "block.minecraft.gravel": "жвір",
  "block.minecraft.gold_ore": "залатая руда",
  "block.minecraft.iron_ore": "жалезная руда",
  "block.minecraft.coal_ore": "вугальная руда",
  "block.minecraft.nether_gold_ore": "залатая руда нэдара",
  "block.minecraft.oak_log": "дубовае бервяно",
  "block.minecraft.spruce_log": "яловае бервяно",
  "block.minecraft.birch_log": "бярозавае бервяно",
  "block.minecraft.jungle_log": "бервяно з трапічнай драўніны",
  "block.minecraft.acacia_log": "бервяно з акацыі",
  "block.minecraft.dark_oak_log": "бервяно з цёмнага дубу",
  "block.minecraft.crimson_stem": "барвовае сцябло",
  "block.minecraft.warped_stem": "скажонае сцябло",
  "block.minecraft.stripped_oak_log": "абчасанае дубовае бервяно",
  "block.minecraft.stripped_spruce_log": "абчасанае яловае бервяно",
  "block.minecraft.stripped_birch_log": "абчасанае бярозавае бервяно",
  "block.minecraft.stripped_jungle_log": "абчасанае бервяно трапічнага дрэва",
  "block.minecraft.stripped_acacia_log": "абчасанае бервяно акацыі",
  "block.minecraft.stripped_dark_oak_log": "абчасанае бервяно цёмнага дубу",
  "block.minecraft.stripped_crimson_stem": "ачышчанае барвовае сцябло",
  "block.minecraft.stripped_warped_stem": "ачышчанае скажонае сцябло",
  "block.minecraft.stripped_oak_wood": "абчасанае дубовае бервяно",
  "block.minecraft.stripped_spruce_wood": "абчасанае яловае бервяно",
  "block.minecraft.stripped_birch_wood": "абчасанае бярозавае бервяно",
  "block.minecraft.stripped_jungle_wood": "абчасанае бервяно трапічнага дрэва",
  "block.minecraft.stripped_acacia_wood": "абчасанае бервяно акацыі",
  "block.minecraft.stripped_dark_oak_wood": "абчасанае бервяно цёмнага дубу",
  "block.minecraft.stripped_crimson_hyphae": "ачышчаная барвовая гіфа",
  "block.minecraft.stripped_warped_hyphae": "ачышчаная скажоная гіфа",
  "block.minecraft.oak_wood": "дубовая драўніна",
  "block.minecraft.spruce_wood": "яловая драўніна",
  "block.minecraft.birch_wood": "бярозавая драўніна",
  "block.minecraft.jungle_wood": "трапічная драўніна",
  "block.minecraft.acacia_wood": "драўніна акацыі",
  "block.minecraft.dark_oak_wood": "драўніна цёмнага дуба",
  "block.minecraft.crimson_hyphae": "барвовая гіфа",
  "block.minecraft.warped_hyphae": "скажоная гіфа",
  "block.minecraft.oak_leaves": "дубовае лісце",
  "block.minecraft.spruce_leaves": "ігліца",
  "block.minecraft.birch_leaves": "бярозавае лісце",
  "block.minecraft.jungle_leaves": "трапічнае лісце",
  "block.minecraft.acacia_leaves": "лісце акацыі",
  "block.minecraft.dark_oak_leaves": "лісце цёмнага дуба",
  "block.minecraft.sponge": "губка",
  "block.minecraft.wet_sponge": "мокрая губка",
  "block.minecraft.glass": "шкло",
  "block.minecraft.lapis_ore": "лазурытавая руда",
  "block.minecraft.lapis_block": "лазурытавы блок",
  "block.minecraft.dispenser": "раздавальнік",
  "block.minecraft.sandstone": "пясчанік",
  "block.minecraft.chiseled_sandstone": "разны пясчанік",
  "block.minecraft.cut_sandstone": "гладкі пясчанік",
  "block.minecraft.note_block": "нотны блок",
  "block.minecraft.powered_rail": "энергарэйкі",
  "block.minecraft.detector_rail": "рэйкі з датчыкам",
  "block.minecraft.sticky_piston": "ліпкі поршань",
  "block.minecraft.cobweb": "павуцінне",
  "block.minecraft.grass": "трава",
  "block.minecraft.fern": "папараць",
  "block.minecraft.dead_bush": "мёртвы куст",
  "block.minecraft.seagrass": "марская трава",
  "block.minecraft.sea_pickle": "агняцелка",
  "block.minecraft.piston": "поршань",
  "block.minecraft.white_wool": "белая воўна",
  "block.minecraft.orange_wool": "аранжавая воўна",
  "block.minecraft.magenta_wool": "пурпурная воўна",
  "block.minecraft.light_blue_wool": "блакітная воўна",
  "block.minecraft.yellow_wool": "жоўтая воўна",
  "block.minecraft.lime_wool": "лаймавая воўна",
  "block.minecraft.pink_wool": "ружовая воўна",
  "block.minecraft.gray_wool": "шэрая воўна",
  "block.minecraft.light_gray_wool": "светла-шэрая воўна",
  "block.minecraft.cyan_wool": "бірузовая воўна",
  "block.minecraft.purple_wool": "фіялетавая воўна",
  "block.minecraft.blue_wool": "сіняя воўна",
  "block.minecraft.brown_wool": "карычневая воўна",
  "block.minecraft.green_wool": "зялёная воўна",
  "block.minecraft.red_wool": "чырвоная воўна",
  "block.minecraft.black_wool": "чорная воўна",
  "block.minecraft.dandelion": "дзьмухавец",
  "block.minecraft.poppy": "мак",
  "block.minecraft.blue_orchid": "блакітная архідэя",
  "block.minecraft.allium": "цыбуля",
  "block.minecraft.azure_bluet": "васілёк",
  "block.minecraft.red_tulip": "чырвоны цюльпан",
  "block.minecraft.orange_tulip": "аранжавы цюльпан",
  "block.minecraft.white_tulip": "белы цюльпан",
  "block.minecraft.pink_tulip": "ружовы цюльпан",
  "block.minecraft.oxeye_daisy": "цюцюпан",
  "block.minecraft.cornflower": "валошка",
  "block.minecraft.lily_of_the_valley": "ландыш",
  "block.minecraft.wither_rose": "ружа відара",
  "block.minecraft.brown_mushroom": "баравік",
  "block.minecraft.red_mushroom": "мухамор",
  "block.minecraft.crimson_fungus": "барвовы грыб",
  "block.minecraft.warped_fungus": "скажоны грыб",
  "block.minecraft.crimson_roots": "барвовыя карані",
  "block.minecraft.warped_roots": "скажоныя карані",
  "block.minecraft.nether_sprouts": "нэдарскія парасткі",
  "block.minecraft.weeping_vines": "ніцыя лозы",
  "block.minecraft.twisting_vines": "перакручаныя лозы",
  "block.minecraft.sugar_cane": "цукровы трыснёг",
  "block.minecraft.kelp": "ламінарыя",
  "block.minecraft.bamboo": "бамбук",
  "block.minecraft.gold_block": "залаты блок",
  "block.minecraft.iron_block": "жалезны блок",
  "block.minecraft.oak_slab": "дубовая пліта",
  "block.minecraft.spruce_slab": "яловая пліта",
  "block.minecraft.birch_slab": "бярозавая пліта",
  "block.minecraft.jungle_slab": "пліта з трапічнай драўніны",
  "block.minecraft.acacia_slab": "пліта з акацыі",
  "block.minecraft.dark_oak_slab": "пліта з цёмнага дубу",
  "block.minecraft.crimson_slab": "барвовая пліта",
  "block.minecraft.warped_slab": "cкажоная пліта",
  "block.minecraft.stone_slab": "каменная пліта",
  "block.minecraft.smooth_stone_slab": "пліта з гладкага каменя",
  "block.minecraft.sandstone_slab": "пліта з пясчаніку",
  "block.minecraft.cut_sandstone_slab": "пліта з гладкага пясчаніку",
  "block.minecraft.petrified_oak_slab": "акамянелая дубовая пліта",
  "block.minecraft.cobblestone_slab": "пліта з буту",
  "block.minecraft.brick_slab": "цагляная пліта",
  "block.minecraft.stone_brick_slab": "пліта з каменнай цэглы",
  "block.minecraft.nether_brick_slab": "пліта з нэдарскай цэглы",
  "block.minecraft.quartz_slab": "кварцавая пліта",
  "block.minecraft.red_sandstone_slab": "пліта з чырвонага пясчаніку",
  "block.minecraft.cut_red_sandstone_slab": "пліта з гладкага чырвонага пясчаніку",
  "block.minecraft.purpur_slab": "пурпуровая пліта",
  "block.minecraft.prismarine_slab": "пліта з прызмарыну",
  "block.minecraft.prismarine_brick_slab": "пліта з прызмарынавай цэглы",
  "block.minecraft.dark_prismarine_slab": "пліта з цёмнага прызмарыну",
  "block.minecraft.smooth_quartz": "блок гладкага кварцу",
  "block.minecraft.smooth_red_sandstone": "гладкі чырвоны пясчанік",
  "block.minecraft.smooth_sandstone": "гладкі пясчанік",
  "block.minecraft.smooth_stone": "гладкі камень",
  "block.minecraft.bricks": "цэгла",
  "block.minecraft.tnt": "дынаміт",
  "block.minecraft.bookshelf": "кніжная палічка",
  "block.minecraft.mossy_cobblestone": "замшэлы бут",
  "block.minecraft.obsidian": "абсідыян",
  "block.minecraft.torch": "факел",
  "block.minecraft.end_rod": "эндар-стрыжань",
  "block.minecraft.chorus_plant": "хорус",
  "block.minecraft.chorus_flower": "кветка хоруса",
  "block.minecraft.purpur_block": "блок пурпуру",
  "block.minecraft.purpur_pillar": "пурпуровая калона",
  "block.minecraft.purpur_stairs": "пурпуровыя прыступкі",
  "block.minecraft.spawner": "рассаднік",
  "block.minecraft.oak_stairs": "дубовыя прыступкі",
  "block.minecraft.chest": "куфар",
  "block.minecraft.diamond_ore": "дыяментавая руда",
  "block.minecraft.diamond_block": "дыяментавы блок",
  "block.minecraft.crafting_table": "варштат",
  "block.minecraft.farmland": "ралля",
  "block.minecraft.furnace": "печка",
  "block.minecraft.ladder": "лесвіца",
  "block.minecraft.rail": "рэйкі",
  "block.minecraft.cobblestone_stairs": "прыступкі з буту",
  "block.minecraft.lever": "рычаг",
  "block.minecraft.stone_pressure_plate": "каменная націскная пліта",
  "block.minecraft.oak_pressure_plate": "дубовая націскная пліта",
  "block.minecraft.spruce_pressure_plate": "яловая націскная пліта",
  "block.minecraft.birch_pressure_plate": "бярозавая націскная пліта",
  "block.minecraft.jungle_pressure_plate": "націскная пліта з трапічнай драўніны",
  "block.minecraft.acacia_pressure_plate": "націскная пліта з акацыі",
  "block.minecraft.dark_oak_pressure_plate": "націскная пліта з цёмнага дубу",
  "block.minecraft.crimson_pressure_plate": "барвовая націскная пліта",
  "block.minecraft.warped_pressure_plate": "cкажоная націскная пліта",
  "block.minecraft.polished_blackstone_pressure_plate": "націскная пліта з паліраванага чарніту",
  "block.minecraft.redstone_ore": "рэдстоўнавая руда",
  "block.minecraft.redstone_torch": "рэдстоўнавы факел",
  "block.minecraft.snow": "снег",
  "block.minecraft.ice": "лёд",
  "block.minecraft.snow_block": "блок снегу",
  "block.minecraft.cactus": "кактус",
  "block.minecraft.clay": "гліна",
  "block.minecraft.jukebox": "прайгравальнік",
  "block.minecraft.oak_fence": "дубовы плот",
  "block.minecraft.spruce_fence": "яловы плот",
  "block.minecraft.birch_fence": "бярозавы плот",
  "block.minecraft.jungle_fence": "плот з трапічнай драўніны",
  "block.minecraft.acacia_fence": "плот з акацыі",
  "block.minecraft.dark_oak_fence": "плот з цёмнага дубу",
  "block.minecraft.crimson_fence": "барвовы плот",
  "block.minecraft.warped_fence": "скажоны плот",
  "block.minecraft.pumpkin": "гарбуз",
  "block.minecraft.carved_pumpkin": "выразаны гарбуз",
  "block.minecraft.netherrack": "камень нэдара",
  "block.minecraft.soul_sand": "пясок душ",
  "block.minecraft.soul_soil": "глеба душ",
  "block.minecraft.basalt": "базальт",
  "block.minecraft.polished_basalt": "паліраваны базальт",
  "block.minecraft.soul_torch": "факел душ",
  "block.minecraft.glowstone": "зіхатлівы камень",
  "block.minecraft.jack_o_lantern": "свяцільня джэка",
  "block.minecraft.oak_trapdoor": "дубовы люк",
  "block.minecraft.spruce_trapdoor": "яловы люк",
  "block.minecraft.birch_trapdoor": "бярозавы люк",
  "block.minecraft.jungle_trapdoor": "люк з трапічнай драўніны",
  "block.minecraft.acacia_trapdoor": "люк з акацыі",
  "block.minecraft.dark_oak_trapdoor": "люк з цёмнага дубу",
  "block.minecraft.crimson_trapdoor": "барвовы люк",
  "block.minecraft.warped_trapdoor": "cкажоны люк",
  "block.minecraft.infested_stone": "заражаны камень",
  "block.minecraft.infested_cobblestone": "заражаны бут",
  "block.minecraft.infested_stone_bricks": "заражаная каменная цэгла",
  "block.minecraft.infested_mossy_stone_bricks": "заражаная замшэлая каменная цэгла",
  "block.minecraft.infested_cracked_stone_bricks": "заражаная патрэская каменная цэгла",
  "block.minecraft.infested_chiseled_stone_bricks": "заражаная разная каменная цэгла",
  "block.minecraft.stone_bricks": "каменная цэгла",
  "block.minecraft.mossy_stone_bricks": "замшэлая каменная цэгла",
  "block.minecraft.cracked_stone_bricks": "патрэсканая каменная цэгла",
  "block.minecraft.chiseled_stone_bricks": "разная каменная цэгла",
  "block.minecraft.brown_mushroom_block": "блок баравіка",
  "block.minecraft.red_mushroom_block": "блок мухамора",
  "block.minecraft.mushroom_stem": "ножка грыба",
  "block.minecraft.iron_bars": "жалезныя краты",
  "block.minecraft.chain": "ланцуг",
  "block.minecraft.glass_pane": "шыба",
  "block.minecraft.melon": "кавун",
  "block.minecraft.vine": "лаза",
  "block.minecraft.oak_fence_gate": "дубовая брамка",
  "block.minecraft.spruce_fence_gate": "яловая брамка",
  "block.minecraft.birch_fence_gate": "бярозавая брамка",
  "block.minecraft.jungle_fence_gate": "брамка з трапічнай драўніны",
  "block.minecraft.acacia_fence_gate": "брамка з акацыі",
  "block.minecraft.dark_oak_fence_gate": "брамка з цёмнага дубу",
  "block.minecraft.crimson_fence_gate": "барвовая брамка",
  "block.minecraft.warped_fence_gate": "cкажоная брамка",
  "block.minecraft.brick_stairs": "цагляныя прыступкі",
  "block.minecraft.stone_brick_stairs": "прыступкі з каменнай цэглы",
  "block.minecraft.mycelium": "міцэлій",
  "block.minecraft.lily_pad": "гарлачык",
  "block.minecraft.nether_bricks": "нэдарская цэгла",
  "block.minecraft.cracked_nether_bricks": "патрэсканая нэдарская цэгла",
  "block.minecraft.chiseled_nether_bricks": "разная нэдарская цэгла",
  "block.minecraft.nether_brick_fence": "плот з нэдарскай цэглы",
  "block.minecraft.nether_brick_stairs": "прыступкі з нэдарскай цэглы",
  "block.minecraft.enchanting_table": "чараўніцкі стол",
  "block.minecraft.end_portal_frame": "рамка партала ў энд",
  "block.minecraft.end_stone": "камень энда",
  "block.minecraft.end_stone_bricks": "цэгла з камню энда",
  "block.minecraft.dragon_egg": "яйка цмока",
  "block.minecraft.redstone_lamp": "ліхтар",
  "block.minecraft.sandstone_stairs": "прыступкі з пясчаніку",
  "block.minecraft.emerald_ore": "смарагдавая руда",
  "block.minecraft.ender_chest": "эндар-куфар",
  "block.minecraft.tripwire_hook": "крук",
  "block.minecraft.emerald_block": "смарагдавы блок",
  "block.minecraft.spruce_stairs": "яловыя прыступкі",
  "block.minecraft.birch_stairs": "бярозавыя прыступкі",
  "block.minecraft.jungle_stairs": "прыступкі з трапічнай драўніны",
  "block.minecraft.crimson_stairs": "барвовыя прыступкі",
  "block.minecraft.warped_stairs": "скажоныя прыступкі",
  "block.minecraft.command_block": "камандны блок",
  "block.minecraft.beacon": "маяк",
  "block.minecraft.cobblestone_wall": "сцяна з буту",
  "block.minecraft.mossy_cobblestone_wall": "сцяна з замшэлага буту",
  "block.minecraft.brick_wall": "цагляная сцяна",
  "block.minecraft.prismarine_wall": "сцяна з прызмарыну",
  "block.minecraft.red_sandstone_wall": "сцяна з чырвонага пясчаніку",
  "block.minecraft.mossy_stone_brick_wall": "замшэлая сцяна з каменнай цэглы",
  "block.minecraft.granite_wall": "сцяна з граніту",
  "block.minecraft.stone_brick_wall": "сцяна з каменнай цэглы",
  "block.minecraft.nether_brick_wall": "сцяна з нэдарскай цэглы",
  "block.minecraft.andesite_wall": "сцяна з андэзіту",
  "block.minecraft.red_nether_brick_wall": "сцяна з чырвонай нэдарскай цэглы",
  "block.minecraft.sandstone_wall": "сцяна з пясчаніку",
  "block.minecraft.end_stone_brick_wall": "сцяна з цэглы з камню энда",
  "block.minecraft.diorite_wall": "сцяна з дыярыту",
  "block.minecraft.blackstone_wall": "сцяна з чарніту",
  "block.minecraft.polished_blackstone_wall": "сцяна з паліраванага чарніту",
  "block.minecraft.polished_blackstone_brick_wall": "сцяна з паліраванай чарнітавай цэглы",
  "block.minecraft.stone_button": "каменная кнопка",
  "block.minecraft.oak_button": "дубовая кнопка",
  "block.minecraft.spruce_button": "яловая кнопка",
  "block.minecraft.birch_button": "бярозавая кнопка",
  "block.minecraft.jungle_button": "кнопка з трапічнай драўніны",
  "block.minecraft.acacia_button": "кнопка з акацыі",
  "block.minecraft.dark_oak_button": "кнопка з цёмнага дубу",
  "block.minecraft.crimson_button": "барвовая кнопка",
  "block.minecraft.warped_button": "скажоная кнопка",
  "block.minecraft.polished_blackstone_button": "паліраваная кнопка з чарніту",
  "block.minecraft.anvil": "кавадла",
  "block.minecraft.chipped_anvil": "пашкоджанае кавадла",
  "block.minecraft.damaged_anvil": "паламанае кавадла",
  "block.minecraft.trapped_chest": "куфар-пастка",
  "block.minecraft.light_weighted_pressure_plate": "вагавая націскная пліта (лёгкая)",
  "block.minecraft.heavy_weighted_pressure_plate": "вагавая націскная пліта (цяжкая)",
  "block.minecraft.daylight_detector": "датчык дзённага святла",
  "block.minecraft.redstone_block": "блок рэдстоўну",
  "block.minecraft.nether_quartz_ore": "кварцавая руда",
  "block.minecraft.hopper": "варонка",
  "block.minecraft.chiseled_quartz_block": "разны кварцавы блок",
  "block.minecraft.quartz_block": "кварцавы блок",
  "block.minecraft.quartz_bricks": "кварцавая цэгла",
  "block.minecraft.quartz_pillar": "кварцавая калона",
  "block.minecraft.quartz_stairs": "кварцавыя прыступкі",
  "block.minecraft.activator_rail": "актывуючыя рэйкі",
  "block.minecraft.dropper": "выкідальнік",
  "block.minecraft.white_terracotta": "белая кераміка",
  "block.minecraft.orange_terracotta": "аранжавая кераміка",
  "block.minecraft.magenta_terracotta": "пурпурная кераміка",
  "block.minecraft.light_blue_terracotta": "блакітная кераміка",
  "block.minecraft.yellow_terracotta": "жоўтая кераміка",
  "block.minecraft.lime_terracotta": "лаймавая кераміка",
  "block.minecraft.pink_terracotta": "ружовая кераміка",
  "block.minecraft.gray_terracotta": "шэрая кераміка",
  "block.minecraft.light_gray_terracotta": "светла-шэрая кераміка",
  "block.minecraft.cyan_terracotta": "бірузовая кераміка",
  "block.minecraft.purple_terracotta": "фіялетавая кераміка",
  "block.minecraft.blue_terracotta": "сіняя кераміка",
  "block.minecraft.brown_terracotta": "карычневая кераміка",
  "block.minecraft.green_terracotta": "зялёная кераміка",
  "block.minecraft.red_terracotta": "чырвоная кераміка",
  "block.minecraft.black_terracotta": "чорная кераміка",
  "block.minecraft.barrier": "бар’ер",
  "block.minecraft.iron_trapdoor": "жалезны люк",
  "block.minecraft.hay_block": "цюк сена",
  "block.minecraft.white_carpet": "белы дыван",
  "block.minecraft.orange_carpet": "аранжавы дыван",
  "block.minecraft.magenta_carpet": "пурпурны дыван",
  "block.minecraft.light_blue_carpet": "блакітны дыван",
  "block.minecraft.yellow_carpet": "жоўты дыван",
  "block.minecraft.lime_carpet": "лаймавы дыван",
  "block.minecraft.pink_carpet": "ружовы дыван",
  "block.minecraft.gray_carpet": "шэры дыван",
  "block.minecraft.light_gray_carpet": "светла-шэры дыван",
  "block.minecraft.cyan_carpet": "бірузовы дыван",
  "block.minecraft.purple_carpet": "фіялетавы дыван",
  "block.minecraft.blue_carpet": "сіні дыван",
  "block.minecraft.brown_carpet": "карычневы дыван",
  "block.minecraft.green_carpet": "зялёны дыван",
  "block.minecraft.red_carpet": "чырвоны дыван",
  "block.minecraft.black_carpet": "чорны дыван",
  "block.minecraft.terracotta": "кераміка",
  "block.minecraft.coal_block": "вугальны блок",
  "block.minecraft.packed_ice": "цвёрды лёд",
  "block.minecraft.acacia_stairs": "прыступкі з акацыі",
  "block.minecraft.dark_oak_stairs": "прыступкі з цёмнага дубу",
  "block.minecraft.slime_block": "блок слізі",
  "block.minecraft.grass_path": "сцежка",
  "block.minecraft.sunflower": "сланечнік",
  "block.minecraft.lilac": "бэз",
  "block.minecraft.rose_bush": "ружовы куст",
  "block.minecraft.peony": "півоня",
  "block.minecraft.tall_grass": "высокая трава",
  "block.minecraft.large_fern": "вялікая папараць",
  "block.minecraft.white_stained_glass": "белае шкло",
  "block.minecraft.orange_stained_glass": "аранжавае шкло",
  "block.minecraft.magenta_stained_glass": "пурпурнае шкло",
  "block.minecraft.light_blue_stained_glass": "блакітнае шкло",
  "block.minecraft.yellow_stained_glass": "жоўтае шкло",
  "block.minecraft.lime_stained_glass": "лаймавае шкло",
  "block.minecraft.pink_stained_glass": "ружовае шкло",
  "block.minecraft.gray_stained_glass": "шэрае шкло",
  "block.minecraft.light_gray_stained_glass": "светла-шэрае шкло",
  "block.minecraft.cyan_stained_glass": "бірузовае шкло",
  "block.minecraft.purple_stained_glass": "фіялетавае шкло",
  "block.minecraft.blue_stained_glass": "сіняе шкло",
  "block.minecraft.brown_stained_glass": "карычневае шкло",
  "block.minecraft.green_stained_glass": "зялёнае шкло",
  "block.minecraft.red_stained_glass": "чырвонае шкло",
  "block.minecraft.black_stained_glass": "чорнае шкло",
  "block.minecraft.white_stained_glass_pane": "белая шыба",
  "block.minecraft.orange_stained_glass_pane": "аранжавая шыба",
  "block.minecraft.magenta_stained_glass_pane": "пурпурная шыба",
  "block.minecraft.light_blue_stained_glass_pane": "блакітная шыба",
  "block.minecraft.yellow_stained_glass_pane": "жоўтая шыба",
  "block.minecraft.lime_stained_glass_pane": "лаймавая шыба",
  "block.minecraft.pink_stained_glass_pane": "ружовая шыба",
  "block.minecraft.gray_stained_glass_pane": "шэрая шыба",
  "block.minecraft.light_gray_stained_glass_pane": "светла-шэрая шыба",
  "block.minecraft.cyan_stained_glass_pane": "бірузовая шыба",
  "block.minecraft.purple_stained_glass_pane": "фіялетавая шыба",
  "block.minecraft.blue_stained_glass_pane": "сіняя шыба",
  "block.minecraft.brown_stained_glass_pane": "карычневая шыба",
  "block.minecraft.green_stained_glass_pane": "зялёная шыба",
  "block.minecraft.red_stained_glass_pane": "чырвоная шыба",
  "block.minecraft.black_stained_glass_pane": "чорная шыба",
  "block.minecraft.prismarine": "прызмарын",
  "block.minecraft.prismarine_bricks": "прызмарынавая цэгла",
  "block.minecraft.dark_prismarine": "цёмны прызмарын",
  "block.minecraft.prismarine_stairs": "прызмарынавыя прыступкі",
  "block.minecraft.prismarine_brick_stairs": "прыступкі з прызмарынавай цэглы",
  "block.minecraft.dark_prismarine_stairs": "цёмныя прызмарынавыя прыступкі",
  "block.minecraft.sea_lantern": "марскі ліхтар",
  "block.minecraft.red_sandstone": "чырвоны пясчанік",
  "block.minecraft.chiseled_red_sandstone": "разны чырвоны пясчанік",
  "block.minecraft.cut_red_sandstone": "гладкі чырвоны пясчанік",
  "block.minecraft.red_sandstone_stairs": "прыступкі з чырвонага пясчаніку",
  "block.minecraft.repeating_command_block": "паўторны камандны блок",
  "block.minecraft.chain_command_block": "ланцуговы камандны блок",
  "block.minecraft.magma_block": "магма",
  "block.minecraft.nether_wart_block": "блок нэдарскай нарасці",
  "block.minecraft.warped_wart_block": "блок скажонай нэдарскай нарасці",
  "block.minecraft.red_nether_bricks": "чырвоная нэдарская цэгла",
  "block.minecraft.bone_block": "касцявы блок",
  "block.minecraft.structure_void": "пустата",
  "block.minecraft.observer": "назіральнік",
  "block.minecraft.shulker_box": "шалкеравая скрыня",
  "block.minecraft.white_shulker_box": "белая шалкеравая скрыня",
  "block.minecraft.orange_shulker_box": "аранжавая шалкеравая скрыня",
  "block.minecraft.magenta_shulker_box": "пурпурная шалкеравая скрыня",
  "block.minecraft.light_blue_shulker_box": "блакітная шалкеравая скрыня",
  "block.minecraft.yellow_shulker_box": "жоўтая шалкеравая скрыня",
  "block.minecraft.lime_shulker_box": "лаймавая шалкеравая скрыня",
  "block.minecraft.pink_shulker_box": "ружовая шалкеравая скрыня",
  "block.minecraft.gray_shulker_box": "шэрая шалкеравая скрыня",
  "block.minecraft.light_gray_shulker_box": "светла-шэрая шалкеравая скрыня",
  "block.minecraft.cyan_shulker_box": "бірузовая шалкеравая скрыня",
  "block.minecraft.purple_shulker_box": "фіялетавая шалкеравая скрыня",
  "block.minecraft.blue_shulker_box": "сіняя шалкеравая скрыня",
  "block.minecraft.brown_shulker_box": "карычневая шалкеравая скрыня",
  "block.minecraft.green_shulker_box": "зяленая шалкеравая скрыня",
  "block.minecraft.red_shulker_box": "чырвоная шалкеравая скрыня",
  "block.minecraft.black_shulker_box": "чорная шалкеравая скрыня",
  "block.minecraft.white_glazed_terracotta": "белая паліваная кераміка",
  "block.minecraft.orange_glazed_terracotta": "аранжавая паліваная кераміка",
  "block.minecraft.magenta_glazed_terracotta": "пурпурная паліваная кераміка",
  "block.minecraft.light_blue_glazed_terracotta": "блакітная паліваная кераміка",
  "block.minecraft.yellow_glazed_terracotta": "жоўтая паліваная кераміка",
  "block.minecraft.lime_glazed_terracotta": "лаймавая паліваная кераміка",
  "block.minecraft.pink_glazed_terracotta": "ружовая паліваная кераміка",
  "block.minecraft.gray_glazed_terracotta": "шэрая паліваная кераміка",
  "block.minecraft.light_gray_glazed_terracotta": "светла-шэрая паліваная кераміка",
  "block.minecraft.cyan_glazed_terracotta": "бірузовая паліваная кераміка",
  "block.minecraft.purple_glazed_terracotta": "фіялетавая паліваная кераміка",
  "block.minecraft.blue_glazed_terracotta": "сіняя паліваная кераміка",
  "block.minecraft.brown_glazed_terracotta": "карычневая паліваная кераміка",
  "block.minecraft.green_glazed_terracotta": "зялёная паліваная кераміка",
  "block.minecraft.red_glazed_terracotta": "чырвоная паліваная кераміка",
  "block.minecraft.black_glazed_terracotta": "чорная паліваная кераміка",
  "block.minecraft.white_concrete": "белы бетон",
  "block.minecraft.orange_concrete": "аранжавы бетон",
  "block.minecraft.magenta_concrete": "пурпурны бетон",
  "block.minecraft.light_blue_concrete": "блакітны бетон",
  "block.minecraft.yellow_concrete": "жоўты бетон",
  "block.minecraft.lime_concrete": "лаймавы бетон",
  "block.minecraft.pink_concrete": "ружовы бетон",
  "block.minecraft.gray_concrete": "шэры бетон",
  "block.minecraft.light_gray_concrete": "светла-шэры бетон",
  "block.minecraft.cyan_concrete": "бірузовы бетон",
  "block.minecraft.purple_concrete": "фіялетавы бетон",
  "block.minecraft.blue_concrete": "сіні бетон",
  "block.minecraft.brown_concrete": "карычневы бетон",
  "block.minecraft.green_concrete": "зялёны бетон",
  "block.minecraft.red_concrete": "чырвоны бетон",
  "block.minecraft.black_concrete": "чорны бетон",
  "block.minecraft.white_concrete_powder": "белы цэмент",
  "block.minecraft.orange_concrete_powder": "аранжавы цэмент",
  "block.minecraft.magenta_concrete_powder": "пурпурны цэмент",
  "block.minecraft.light_blue_concrete_powder": "блакітны цэмент",
  "block.minecraft.yellow_concrete_powder": "жоўты цэмент",
  "block.minecraft.lime_concrete_powder": "лаймавы цэмент",
  "block.minecraft.pink_concrete_powder": "ружовы цэмент",
  "block.minecraft.gray_concrete_powder": "шэры цэмент",
  "block.minecraft.light_gray_concrete_powder": "светла-шэры цэмент",
  "block.minecraft.cyan_concrete_powder": "бірузовы цэмент",
  "block.minecraft.purple_concrete_powder": "фіялетавы цэмент",
  "block.minecraft.blue_concrete_powder": "сіні цэмент",
  "block.minecraft.brown_concrete_powder": "карычневы цэмент",
  "block.minecraft.green_concrete_powder": "зялёны цэмент",
  "block.minecraft.red_concrete_powder": "чырвоны цэмент",
  "block.minecraft.black_concrete_powder": "чорны цэмент",
  "block.minecraft.turtle_egg": "яйка чарапахі",
  "block.minecraft.dead_tube_coral_block": "блок мёртвага трубчастага карала",
  "block.minecraft.dead_brain_coral_block": "блок мёртвага мазгавога карала",
  "block.minecraft.dead_bubble_coral_block": "блок мёртвага пузырыстага карала",
  "block.minecraft.dead_fire_coral_block": "блок мёртвага агністага карала",
  "block.minecraft.dead_horn_coral_block": "блок мёртвага рагавога карала",
  "block.minecraft.tube_coral_block": "блок трубчастага карала",
  "block.minecraft.brain_coral_block": "блок мазгавога карала",
  "block.minecraft.bubble_coral_block": "блок пузырыстага карала",
  "block.minecraft.fire_coral_block": "блок агністага карала",
  "block.minecraft.horn_coral_block": "блок рагавога карала",
  "block.minecraft.tube_coral": "трубчасты карал",
  "block.minecraft.brain_coral": "мазгавы карал",
  "block.minecraft.bubble_coral": "пузырысты карал",
  "block.minecraft.fire_coral": "агністы карал",
  "block.minecraft.horn_coral": "рагавы карал",
  "block.minecraft.dead_brain_coral": "мёртвы мазгавы карал",
  "block.minecraft.dead_bubble_coral": "мёртвы пузырысты карал",
  "block.minecraft.dead_fire_coral": "мёртвы агністы карал",
  "block.minecraft.dead_horn_coral": "мёртвы рагавы карал",
  "block.minecraft.dead_tube_coral": "мёртвы трубчасты карал",
  "block.minecraft.tube_coral_fan": "веерны трубчасты карал",
  "block.minecraft.brain_coral_fan": "веерны мазгавы карал",
  "block.minecraft.bubble_coral_fan": "веерны пузырысты карал",
  "block.minecraft.fire_coral_fan": "веерны агністы карал",
  "block.minecraft.horn_coral_fan": "веерны рагавы карал",
  "block.minecraft.dead_tube_coral_fan": "мёртвы веерны трубчасты карал",
  "block.minecraft.dead_brain_coral_fan": "мёртвы веерны мазгавы карал",
  "block.minecraft.dead_bubble_coral_fan": "мёртвы веерны пузырысты карал",
  "block.minecraft.dead_fire_coral_fan": "мёртвы веерны агністы карал",
  "block.minecraft.dead_horn_coral_fan": "мёртвы веерны рагавы карал",
  "block.minecraft.blue_ice": "сіні лёд",
  "block.minecraft.conduit": "сфера марскіх чараў",
  "block.minecraft.polished_granite_stairs": "прыступкі з паліраванага граніту",
  "block.minecraft.smooth_red_sandstone_stairs": "прыступкі з гладкага чырвонага пясчаніку",
  "block.minecraft.mossy_stone_brick_stairs": "замшэлыя прыступкі з каменнай цэглы",
  "block.minecraft.polished_diorite_stairs": "прыступкі з паліраванага дыярыту",
  "block.minecraft.mossy_cobblestone_stairs": "замшэлыя прыступкі з буту",
  "block.minecraft.end_stone_brick_stairs": "прыступкі з цэглы энда",
  "block.minecraft.stone_stairs": "каменныя прыступкі",
  "block.minecraft.smooth_sandstone_stairs": "прыступкі з гладкага пясчаніку",
  "block.minecraft.smooth_quartz_stairs": "прыступкі з гладкага кварцу",
  "block.minecraft.granite_stairs": "прыступкі з граніту",
  "block.minecraft.andesite_stairs": "прыступкі з андэзіту",
  "block.minecraft.red_nether_brick_stairs": "прыступкі з чырвонай нэдарскай цэглы",
  "block.minecraft.polished_andesite_stairs": "прыступкі з паліраванага андэзіту",
  "block.minecraft.diorite_stairs": "прыступкі з дыярыту",
  "block.minecraft.polished_granite_slab": "пліта з паліраванага граніту",
  "block.minecraft.smooth_red_sandstone_slab": "пліта з гладкага чырвонага пясчаніку",
  "block.minecraft.mossy_stone_brick_slab": "замшэлая пліта з каменнай цэглы",
  "block.minecraft.polished_diorite_slab": "пліта з паліраванага дыярыту",
  "block.minecraft.mossy_cobblestone_slab": "замшэлая пліта з буту",
  "block.minecraft.end_stone_brick_slab": "пліта з цэглы энда",
  "block.minecraft.smooth_sandstone_slab": "пліта з гладкага пясчаніку",
  "block.minecraft.smooth_quartz_slab": "пліта з гладкага кварцу",
  "block.minecraft.granite_slab": "пліта з граніту",
  "block.minecraft.andesite_slab": "пліта з андэзіту",
  "block.minecraft.red_nether_brick_slab": "пліта з чырвонай нэдарскай цэглы",
  "block.minecraft.polished_andesite_slab": "пліта з паліраванага андэзіту",
  "block.minecraft.diorite_slab": "пліта з дыярыту",
  "block.minecraft.scaffolding": "рыштаванні",
  "block.minecraft.iron_door": "жалезныя дзверы",
  "block.minecraft.oak_door": "дубовыя дзверы",
  "block.minecraft.spruce_door": "яловыя дзверы",
  "block.minecraft.birch_door": "бярозавыя дзверы",
  "block.minecraft.jungle_door": "дзверы з трапічнай драўніны",
  "block.minecraft.acacia_door": "дзверы з акацыі",
  "block.minecraft.dark_oak_door": "дзверы з цёмнага дубу",
  "block.minecraft.crimson_door": "барвовыя дзверы",
  "block.minecraft.warped_door": "скажоныя дзверы",
  "block.minecraft.repeater": "паўтаральнік",
  "block.minecraft.comparator": "кампаратар",
  "block.minecraft.structure_block": "праектны блок",
  "block.minecraft.jigsaw": "канструкцыйны блок",
  "item.minecraft.turtle_helmet": "панцыр чарапахі□□калі апранута на галаву:□+2 браня",
  "item.minecraft.scute": "лускавінка",
  "item.minecraft.iron_shovel": "жалезная рыдлёўка□□калі ў асноўнай руцэ:□+3.5 пашкоджанні□-3 хуткасць атакі",
  "item.minecraft.iron_pickaxe": "жалезная кірка□□калі ў асноўнай руцэ:□+3 пашкоджанні□-2.8 хуткасць атакі",
  "item.minecraft.iron_axe": "жалезная сякера□□калі ў асноўнай руцэ:□+8 пашкоджанні□-3.1 хуткасць атакі",
  "item.minecraft.flint_and_steel": "крэсіва",
  "item.minecraft.apple": "яблык",
  "item.minecraft.bow": "лук",
  "item.minecraft.arrow": "страла",
  "item.minecraft.coal": "вугаль",
  "item.minecraft.charcoal": "драўняны вугаль",
  "item.minecraft.diamond": "дыямент",
  "item.minecraft.iron_ingot": "жалезны злітак",
  "item.minecraft.gold_ingot": "залаты злітак",
  "item.minecraft.netherite_ingot": "нэдарытавы злітак",
  "item.minecraft.netherite_scrap": "нэдарытавы абломак",
  "item.minecraft.iron_sword": "жалезны меч□□калі ў асноўнай руцэ:□+5 пашкоджанні□-2.4 хуткасць атакі",
  "item.minecraft.wooden_sword": "драўляны меч□□калі ў асноўнай руцэ:□+3 пашкоджанні□-2.4 хуткасць атакі",
  "item.minecraft.wooden_shovel": "драўляная рыдлёўка□□калі ў асноўнай руцэ:□+1.5 пашкоджанні□-3 хуткасць атакі",
  "item.minecraft.wooden_pickaxe": "драўляная кірка□□калі ў асноўнай руцэ:□+1 пашкоджанні□-2.8 хуткасць атакі",
  "item.minecraft.wooden_axe": "драўляная сякера□□калі ў асноўнай руцэ:□+6 пашкоджанні□-3.2 хуткасць атакі",
  "item.minecraft.stone_sword": "каменны меч□□калі ў асноўнай руцэ:□+4 пашкоджанні□-2.4 хуткасць атакі",
  "item.minecraft.stone_shovel": "каменная рыдлёўка□□калі ў асноўнай руцэ:□+2.5 пашкоджанні□-3 хуткасць атакі",
  "item.minecraft.stone_pickaxe": "каменная кірка□□калі ў асноўнай руцэ:□+2 пашкоджанні□-2.8 хуткасць атакі",
  "item.minecraft.stone_axe": "каменная сякера□□калі ў асноўнай руцэ:□+8 пашкоджанні□-3.2 хуткасць атакі",
  "item.minecraft.diamond_sword": "дыяментавы меч□□калі ў асноўнай руцэ:□+6 пашкоджанні□-2.4 хуткасць атакі",
  "item.minecraft.diamond_shovel": "дыяментавая рыдлёўка□□калі ў асноўнай руцэ:□+4.5 пашкоджанні□-3 хуткасць атакі",
  "item.minecraft.diamond_pickaxe": "дыяментавая кірка□□калі ў асноўнай руцэ:□+4 пашкоджанні□-2.8 хуткасць атакі",
  "item.minecraft.diamond_axe": "дыяментавая сякера□□калі ў асноўнай руцэ:□+8 пашкоджанні□-3 хуткасць атакі",
  "item.minecraft.stick": "палка",
  "item.minecraft.bowl": "міска",
  "item.minecraft.mushroom_stew": "тушаныя грыбы",
  "item.minecraft.golden_sword": "залаты меч□□калі ў асноўнай руцэ:□+3 пашкоджанні□-2.4 хуткасць атакі",
  "item.minecraft.golden_shovel": "залатая рыдлёўка□□калі ў асноўнай руцэ:□+1.5 пашкоджанні□-3 хуткасць атакі",
  "item.minecraft.golden_pickaxe": "залатая кірка□□калі ў асноўнай руцэ:□+1 пашкоджанні□-2.8 хуткасць атакі",
  "item.minecraft.golden_axe": "залатая сякера□□калі ў асноўнай руцэ:□+6 пашкоджанні□-3 хуткасць атакі",
  "item.minecraft.netherite_sword": "нэдарытавы меч□□калі ў асноўнай руцэ:□+7 пашкоджанні□-2.4 хуткасць атакі",
  "item.minecraft.netherite_shovel": "нэдарытавая рыдлёўка□□калі ў асноўнай руцэ:□+5.5 пашкоджанні□-3 хуткасць атакі",
  "item.minecraft.netherite_pickaxe": "нэдарытавая кірка□□калі ў асноўнай руцэ:□+5 пашкоджанні□-2.8 хуткасць атакі",
  "item.minecraft.netherite_axe": "нэдарытавая сякера□□калі ў асноўнай руцэ:□+9 пашкоджанні□-3 хуткасць атакі",
  "item.minecraft.string": "нітка",
  "item.minecraft.feather": "пяро",
  "item.minecraft.gunpowder": "порах",
  "item.minecraft.wooden_hoe": "драўляная матыка□□калі ў асноўнай руцэ:□-3 хуткасць атакі",
  "item.minecraft.stone_hoe": "каменная матыка□□калі ў асноўнай руцэ:□-2 хуткасць атакі",
  "item.minecraft.iron_hoe": "жалезная матыка□□калі ў асноўнай руцэ:□-1 хуткасць атакі",
  "item.minecraft.diamond_hoe": "дыяментавая матыка□□калі ў асноўнай руцэ:",
  "item.minecraft.golden_hoe": "залатая матыка□□калі ў асноўнай руцэ:□-3 хуткасць атакі",
  "item.minecraft.netherite_hoe": "нэдарытавая матыка□□калі ў асноўнай руцэ:",
  "item.minecraft.wheat_seeds": "зерне пшаніцы",
  "item.minecraft.wheat": "пшаніца",
  "item.minecraft.bread": "хлеб",
  "item.minecraft.leather_helmet": "скураная шапка□□калі апранута на галаву:□+1 браня",
  "item.minecraft.leather_chestplate": "скураная куртка□□калі апранута на цела:□+3 браня",
  "item.minecraft.leather_leggings": "скураныя нагавіцы□□калі апранута на ногі:□+2 браня",
  "item.minecraft.leather_boots": "скураныя боты□□калі абута:□+1 браня",
  "item.minecraft.chainmail_helmet": "кальчужны шлем□□калі апранута на галаву:□+2 браня",
  "item.minecraft.chainmail_chestplate": "кальчужны нагруднік□□калі апранута на цела:□+5 браня",
  "item.minecraft.chainmail_leggings": "кальчужныя понажы□□калі апранута на ногі:□+4 браня",
  "item.minecraft.chainmail_boots": "кальчужныя боты□□калі абута:□+1 браня",
  "item.minecraft.iron_helmet": "жалезны шлем□□калі апранута на галаву:□+2 браня",
  "item.minecraft.iron_chestplate": "жалезная кіраса□□калі апранута на цела:□+6 браня",
  "item.minecraft.iron_leggings": "жалезныя понажы□□калі апранута на ногі:□+5 браня",
  "item.minecraft.iron_boots": "жалезныя боты□□калі абута:□+2 браня",
  "item.minecraft.diamond_helmet": "дыяментавы шлем□□калі апранута на галаву:□+3 браня□+2 трываласць брані",
  "item.minecraft.diamond_chestplate": "дыяментавая кіраса□□калі апранута на цела:□+8 браня□+2 трываласць брані",
  "item.minecraft.diamond_leggings": "дыяментавыя понажы□□калі апранута на ногі:□+6 браня□+2 трываласць брані",
  "item.minecraft.diamond_boots": "дыяментавыя боты□□калі абута:□+3 браня□+2 трываласць брані",
  "item.minecraft.golden_helmet": "залаты шлем□□калі апранута на галаву:□+2 браня",
  "item.minecraft.golden_chestplate": "залатая кіраса□□калі апранута на цела:□+5 браня",
  "item.minecraft.golden_leggings": "залатыя понажы□□калі апранута на ногі:□+3 браня",
  "item.minecraft.golden_boots": "залатыя боты□□калі абута:□+1 браня",
  "item.minecraft.netherite_helmet": "нэдарытавы шлем□□калі апранута на галаву:□+3 браня□+3 трываласць брані□+1 супраціў адкіданню",
  "item.minecraft.netherite_chestplate": "нэдарытавая кіраса□□калі апранута на цела:□+8 браня□+3 трываласць брані□+1 супраціў адкіданню",
  "item.minecraft.netherite_leggings": "нэдарытавыя понажы□□калі апранута на ногі:□+6 браня□+3 трываласць брані□+1 супраціў адкіданню",
  "item.minecraft.netherite_boots": "нэдарытавыя боты□□калі абута:□+3 браня□+3 трываласць брані□+1 супраціў адкіданню",
  "item.minecraft.flint": "крэмень",
  "item.minecraft.porkchop": "сырая свініна",
  "item.minecraft.cooked_porkchop": "смажаная свініна",
  "item.minecraft.painting": "карціна",
  "item.minecraft.golden_apple": "залаты яблык",
  "item.minecraft.enchanted_golden_apple": "зачараваны залаты яблык",
  "block.minecraft.oak_sign": "дубовая шыльда",
  "block.minecraft.spruce_sign": "яловая шыльда",
  "block.minecraft.birch_sign": "бярозавая шыльда",
  "block.minecraft.jungle_sign": "шыльда з трапічнай драўніны",
  "block.minecraft.acacia_sign": "шыльда з акацыі",
  "block.minecraft.dark_oak_sign": "шыльда з цёмнага дубу",
  "block.minecraft.crimson_sign": "барвовая шыльда",
  "block.minecraft.warped_sign": "скажоная шыльда",
  "item.minecraft.bucket": "вядро",
  "item.minecraft.water_bucket": "вядро вады",
  "item.minecraft.lava_bucket": "вядро лавы",
  "item.minecraft.minecart": "ваганетка",
  "item.minecraft.saddle": "сядло",
  "item.minecraft.redstone": "рэдстоўнавы пыл",
  "item.minecraft.snowball": "снежка",
  "item.minecraft.oak_boat": "дубовы човен",
  "item.minecraft.leather": "скура",
  "item.minecraft.milk_bucket": "вядро малака",
  "item.minecraft.pufferfish_bucket": "вядро з іголкабрухам",
  "item.minecraft.salmon_bucket": "вядро з ласосем",
  "item.minecraft.cod_bucket": "вядро з траской",
  "item.minecraft.tropical_fish_bucket": "вядро з трапічнай рыбай",
  "item.minecraft.brick": "цагліна",
  "item.minecraft.clay_ball": "гліняны шар",
  "block.minecraft.dried_kelp_block": "блок сушанай ламінарыі",
  "item.minecraft.paper": "папера",
  "item.minecraft.book": "кніга",
  "item.minecraft.slime_ball": "згустак слізі",
  "item.minecraft.chest_minecart": "ваганетка з куфарам",
  "item.minecraft.furnace_minecart": "ваганетка з печкай",
  "item.minecraft.egg": "яйка",
  "item.minecraft.compass": "компас",
  "item.minecraft.fishing_rod": "вудачка",
  "item.minecraft.clock": "гадзіннік",
  "item.minecraft.glowstone_dust": "зіхоткі пыл",
  "item.minecraft.cod": "сырая траска",
  "item.minecraft.salmon": "сыры ласось",
  "item.minecraft.tropical_fish": "трапічная рыба",
  "item.minecraft.pufferfish": "іголкабрух",
  "item.minecraft.cooked_cod": "смажаная траска",
  "item.minecraft.cooked_salmon": "смажаны ласось",
  "item.minecraft.ink_sac": "чарнільны мяшок",
  "item.minecraft.red_dye": "чырвоны фарбавальнік",
  "item.minecraft.green_dye": "зялёны фарбавальнік",
  "item.minecraft.cocoa_beans": "какава-бабы",
  "item.minecraft.lapis_lazuli": "лазурыт",
  "item.minecraft.purple_dye": "фіялетавы фарбавальнік",
  "item.minecraft.cyan_dye": "бірузовы фарбавальнік",
  "item.minecraft.light_gray_dye": "светла-шэры фарбавальнік",
  "item.minecraft.gray_dye": "шэры фарбавальнік",
  "item.minecraft.pink_dye": "ружовы фарбавальнік",
  "item.minecraft.lime_dye": "лаймавы фарбавальнік",
  "item.minecraft.yellow_dye": "жоўты фарбавальнік",
  "item.minecraft.light_blue_dye": "блакітны фарбавальнік",
  "item.minecraft.magenta_dye": "пурпурны фарбавальнік",
  "item.minecraft.orange_dye": "аранжавы фарбавальнік",
  "item.minecraft.bone_meal": "касцявая мука",
  "item.minecraft.blue_dye": "сіні фарбавальнік",
  "item.minecraft.brown_dye": "карычневы фарбавальнік",
  "item.minecraft.black_dye": "чорны фарбавальнік",
  "item.minecraft.white_dye": "белы фарбавальнік",
  "item.minecraft.bone": "косць",
  "item.minecraft.sugar": "цукар",
  "block.minecraft.cake": "торт",
  "block.minecraft.white_bed": "белы ложак",
  "block.minecraft.orange_bed": "аранжавы ложак",
  "block.minecraft.magenta_bed": "пурпурны ложак",
  "block.minecraft.light_blue_bed": "блакітны ложак",
  "block.minecraft.yellow_bed": "жоўты ложак",
  "block.minecraft.lime_bed": "лаймавы ложак",
  "block.minecraft.pink_bed": "ружовы ложак",
  "block.minecraft.gray_bed": "шэры ложак",
  "block.minecraft.light_gray_bed": "светла-шэры ложак",
  "block.minecraft.cyan_bed": "бірузовы ложак",
  "block.minecraft.purple_bed": "фіялетавы ложак",
  "block.minecraft.blue_bed": "сіні ложак",
  "block.minecraft.brown_bed": "карычневы ложак",
  "block.minecraft.green_bed": "зялёны ложак",
  "block.minecraft.red_bed": "чырвоны ложак",
  "block.minecraft.black_bed": "чорны ложак",
  "item.minecraft.cookie": "печыва",
  "item.minecraft.filled_map": "карта□#0",
  "item.minecraft.shears": "нажніцы",
  "item.minecraft.melon_slice": "кавалак кавуна",
  "item.minecraft.dried_kelp": "сушаная ламінарыя",
  "item.minecraft.pumpkin_seeds": "насенне гарбуза",
  "item.minecraft.melon_seeds": "насенне кавуна",
  "item.minecraft.beef": "сырая ялавічына",
  "item.minecraft.cooked_beef": "смажаная ялавічына",
  "item.minecraft.chicken": "сырая кураціна",
  "item.minecraft.cooked_chicken": "смажаная кураціна",
  "item.minecraft.rotten_flesh": "гнілое мяса",
  "item.minecraft.ender_pearl": "жамчужына энда",
  "item.minecraft.blaze_rod": "вогненны стрыжань",
  "item.minecraft.ghast_tear": "сляза гаста",
  "item.minecraft.gold_nugget": "кавалак золата",
  "item.minecraft.nether_wart": "нэдарская нарасць",
  "item.minecraft.potion": "нестваральнае зелле□няма эфектаў",
  "item.minecraft.glass_bottle": "пляшка",
  "item.minecraft.spider_eye": "павучынае вока",
  "item.minecraft.fermented_spider_eye": "марынаванае павучынае вока",
  "item.minecraft.blaze_powder": "вогненны парашок",
  "item.minecraft.magma_cream": "згустак магмы",
  "block.minecraft.brewing_stand": "варачная стойка",
  "block.minecraft.cauldron": "кацёл",
  "item.minecraft.ender_eye": "вока эндара",
  "item.minecraft.glistering_melon_slice": "зіхатлівы кавалак кавуна",
  "item.minecraft.bat_spawn_egg": "яйка прызыву - кажан",
  "item.minecraft.bee_spawn_egg": "яйка прызыву - пчала",
  "item.minecraft.blaze_spawn_egg": "яйка прызыву - полымень",
  "item.minecraft.cat_spawn_egg": "яйка прызыву - кот",
  "item.minecraft.cave_spider_spawn_egg": "яйка прызыву - пячорны павук",
  "item.minecraft.chicken_spawn_egg": "яйка прызыву - курыца",
  "item.minecraft.cod_spawn_egg": "яйка прызыву - траска",
  "item.minecraft.cow_spawn_egg": "яйка прызыву - карова",
  "item.minecraft.creeper_spawn_egg": "яйка прызыву - крыпер",
  "item.minecraft.dolphin_spawn_egg": "яйка прызыву - дэльфін",
  "item.minecraft.donkey_spawn_egg": "яйка прызыву - асёл",
  "item.minecraft.drowned_spawn_egg": "яйка прызыву - навец",
  "item.minecraft.elder_guardian_spawn_egg": "яйка прызыву - старажытны вартавы",
  "item.minecraft.enderman_spawn_egg": "яйка прызыву - эндармэн",
  "item.minecraft.endermite_spawn_egg": "яйка прызыву - эндармайт",
  "item.minecraft.evoker_spawn_egg": "яйка прызыву - заклінальнік",
  "item.minecraft.fox_spawn_egg": "яйка прызыву - ліс",
  "item.minecraft.ghast_spawn_egg": "яйка прызыву - гаст",
  "item.minecraft.guardian_spawn_egg": "яйка прызыву - вартавы",
  "item.minecraft.hoglin_spawn_egg": "яйка прызыву - гоглін",
  "item.minecraft.horse_spawn_egg": "яйка прызыву - конь",
  "item.minecraft.husk_spawn_egg": "яйка прызыву - здыхляк",
  "item.minecraft.llama_spawn_egg": "яйка прызыву - лама",
  "item.minecraft.magma_cube_spawn_egg": "яйка прызыву - магмакуб",
  "item.minecraft.mooshroom_spawn_egg": "яйка прызыву - муухамор",
  "item.minecraft.mule_spawn_egg": "яйка прызыву - мул",
  "item.minecraft.ocelot_spawn_egg": "яйка прызыву - ацэлот",
  "item.minecraft.panda_spawn_egg": "яйка прызыву - панда",
  "item.minecraft.parrot_spawn_egg": "яйка прызыву - папугай",
  "item.minecraft.phantom_spawn_egg": "яйка прызыву - фантом",
  "item.minecraft.pig_spawn_egg": "яйка прызыву - свіння",
  "item.minecraft.piglin_spawn_egg": "яйка прызыву - піглін",
  "item.minecraft.pillager_spawn_egg": "яйка прызыву - марадзёр",
  "item.minecraft.polar_bear_spawn_egg": "яйка прызыву - белы мядзведзь",
  "item.minecraft.pufferfish_spawn_egg": "яйка прызыву - іголкабрух",
  "item.minecraft.rabbit_spawn_egg": "яйка прызыву - трус",
  "item.minecraft.ravager_spawn_egg": "яйка прызыву - спусташальнік",
  "item.minecraft.salmon_spawn_egg": "яйка прызыву - ласось",
  "item.minecraft.sheep_spawn_egg": "яйка прызыву - авечка",
  "item.minecraft.shulker_spawn_egg": "яйка прызыву - шалкер",
  "item.minecraft.silverfish_spawn_egg": "яйка прызыву - лускаўніца",
  "item.minecraft.skeleton_spawn_egg": "яйка прызыву - шкілет",
  "item.minecraft.skeleton_horse_spawn_egg": "яйка прызыву - конь-шкілет",
  "item.minecraft.slime_spawn_egg": "яйка прызыву - слімак",
  "item.minecraft.spider_spawn_egg": "яйка прызыву - павук",
  "item.minecraft.squid_spawn_egg": "яйка прызыву - спрут",
  "item.minecraft.stray_spawn_egg": "яйка прызыву - бадзяга",
  "item.minecraft.strider_spawn_egg": "яйка прызыву - лавацуга",
  "item.minecraft.trader_llama_spawn_egg": "яйка прызыву - лама гандляра",
  "item.minecraft.tropical_fish_spawn_egg": "яйка прызыву - трапічная рыба",
  "item.minecraft.turtle_spawn_egg": "яйка прызыву - чарапаха",
  "item.minecraft.vex_spawn_egg": "яйка прызыву - шкоднік",
  "item.minecraft.villager_spawn_egg": "яйка прызыву - селянін",
  "item.minecraft.vindicator_spawn_egg": "яйка прызыву - змагар",
  "item.minecraft.wandering_trader_spawn_egg": "яйка прызыву - вандроўны гандляр",
  "item.minecraft.witch_spawn_egg": "яйка прызыву - ведзьма",
  "item.minecraft.wither_skeleton_spawn_egg": "яйка прызыву - відар-шкілет",
  "item.minecraft.wolf_spawn_egg": "яйка прызыву - воўк",
  "item.minecraft.zoglin_spawn_egg": "яйка прызыву - зоглін",
  "item.minecraft.zombie_spawn_egg": "яйка прызыву - мярцвяк",
  "item.minecraft.zombie_horse_spawn_egg": "яйка прызыву - конь-мярцвяк",
  "item.minecraft.zombie_villager_spawn_egg": "яйка прызыву - мярцвяк-селянін",
  "item.minecraft.zombified_piglin_spawn_egg": "яйка прызыву - мярцвяк-піглін",
  "item.minecraft.experience_bottle": "пляшка досведу",
  "item.minecraft.fire_charge": "вогненны шар",
  "item.minecraft.writable_book": "кніга і пяро",
  "item.minecraft.written_book": "напісаная кніга",
  "item.minecraft.emerald": "смарагд",
  "item.minecraft.item_frame": "рамка",
  "block.minecraft.flower_pot": "гаршчок",
  "item.minecraft.carrot": "морква",
  "item.minecraft.potato": "бульба",
  "item.minecraft.baked_potato": "печаная бульба",
  "item.minecraft.poisonous_potato": "атрутная бульба",
  "item.minecraft.map": "пустая карта",
  "item.minecraft.golden_carrot": "залатая морква",
  "block.minecraft.skeleton_skull": "чэрап",
  "block.minecraft.wither_skeleton_skull": "чэрап відар-шкілета",
  "block.minecraft.player_head": "галава гульца",
  "block.minecraft.zombie_head": "галава мерцвяка",
  "block.minecraft.creeper_head": "галава крыпера",
  "block.minecraft.dragon_head": "галава цмока",
  "item.minecraft.carrot_on_a_stick": "морква на палачцы",
  "item.minecraft.warped_fungus_on_a_stick": "скажоны грыб на палачцы",
  "item.minecraft.nether_star": "зорка нэдара",
  "item.minecraft.pumpkin_pie": "гарбузовы пірог",
  "item.minecraft.firework_rocket": "феерверк",
  "item.minecraft.firework_star": "набой феерверку",
  "item.minecraft.enchanted_book": "зачараваная кніга",
  "item.minecraft.nether_brick": "нэдарская цэгла",
  "item.minecraft.quartz": "кварц",
  "item.minecraft.tnt_minecart": "ваганетка з дынамітам",
  "item.minecraft.hopper_minecart": "ваганетка з варонкай",
  "item.minecraft.prismarine_shard": "прызмарынавы аскепак",
  "item.minecraft.prismarine_crystals": "крышталі прызмарыну",
  "item.minecraft.rabbit": "сырая трусяціна",
  "item.minecraft.cooked_rabbit": "смажаная трусяціна",
  "item.minecraft.rabbit_stew": "тушаны трус",
  "item.minecraft.rabbit_foot": "лапка труса",
  "item.minecraft.rabbit_hide": "шкура труса",
  "item.minecraft.armor_stand": "стойка для брані",
  "item.minecraft.iron_horse_armor": "жалезная конская браня",
  "item.minecraft.golden_horse_armor": "залатая конская браня",
  "item.minecraft.diamond_horse_armor": "дыяментавая конская браня",
  "item.minecraft.leather_horse_armor": "скураная конская браня",
  "item.minecraft.lead": "павадок",
  "item.minecraft.name_tag": "бірка",
  "item.minecraft.command_block_minecart": "ваганетка з камандным блокам",
  "item.minecraft.mutton": "сырая бараніна",
  "item.minecraft.cooked_mutton": "смажаная бараніна",
  "block.minecraft.white_banner": "белы сцяг",
  "block.minecraft.orange_banner": "аранжавы сцяг",
  "block.minecraft.magenta_banner": "пурпурны сцяг",
  "block.minecraft.light_blue_banner": "блакітны сцяг",
  "block.minecraft.yellow_banner": "жоўты сцяг",
  "block.minecraft.lime_banner": "лаймавы сцяг",
  "block.minecraft.pink_banner": "ружовы сцяг",
  "block.minecraft.gray_banner": "шэры сцяг",
  "block.minecraft.light_gray_banner": "светла-шэры сцяг",
  "block.minecraft.cyan_banner": "бірузовы сцяг",
  "block.minecraft.purple_banner": "фіялетавы сцяг",
  "block.minecraft.blue_banner": "сіні сцяг",
  "block.minecraft.brown_banner": "карычневы сцяг",
  "block.minecraft.green_banner": "зялёны сцяг",
  "block.minecraft.red_banner": "чырвоны сцяг",
  "block.minecraft.black_banner": "чорны сцяг",
  "item.minecraft.end_crystal": "крышталь энда",
  "item.minecraft.chorus_fruit": "плод хоруса",
  "item.minecraft.popped_chorus_fruit": "печаны плод хоруса",
  "item.minecraft.beetroot": "бурак",
  "item.minecraft.beetroot_seeds": "насенне бурака",
  "item.minecraft.beetroot_soup": "боршч",
  "item.minecraft.dragon_breath": "дыханне цмока",
  "item.minecraft.splash_potion": "выбухное нестваральнае зелле□няма эфектаў",
  "item.minecraft.spectral_arrow": "спектральная страла",
  "item.minecraft.tipped_arrow": "нествараемая апрацаваная страла□няма эфектаў",
  "item.minecraft.lingering_potion": "трывалае нестваральнае зелле□няма эфектаў",
  "item.minecraft.shield": "шчыт",
  "item.minecraft.elytra": "элітры",
  "item.minecraft.spruce_boat": "яловы човен",
  "item.minecraft.birch_boat": "бярозавы човен",
  "item.minecraft.jungle_boat": "човен з трапічнай драўніны",
  "item.minecraft.acacia_boat": "човен з акацыі",
  "item.minecraft.dark_oak_boat": "човен з цёмнага дубу",
  "item.minecraft.totem_of_undying": "татэм бяссмерця",
  "item.minecraft.shulker_shell": "панцыр шалкера",
  "item.minecraft.iron_nugget": "кавалак жалеза",
  "item.minecraft.knowledge_book": "кніга ведаў",
  "item.minecraft.debug_stick": "палачка адладкі",
  "item.minecraft.music_disc_13": "грампласцінка□c418 - 13",
  "item.minecraft.music_disc_cat": "грампласцінка□c418 - cat",
  "item.minecraft.music_disc_blocks": "грампласцінка□c418 - blocks",
  "item.minecraft.music_disc_chirp": "грампласцінка□c418 - chirp",
  "item.minecraft.music_disc_far": "грампласцінка□c418 - far",
  "item.minecraft.music_disc_mall": "грампласцінка□c418 - mall",
  "item.minecraft.music_disc_mellohi": "грампласцінка□c418 - mellohi",
  "item.minecraft.music_disc_stal": "грампласцінка□c418 - stal",
  "item.minecraft.music_disc_strad": "грампласцінка□c418 - strad",
  "item.minecraft.music_disc_ward": "грампласцінка□c418 - ward",
  "item.minecraft.music_disc_11": "грампласцінка□c418 - 11",
  "item.minecraft.music_disc_wait": "грампласцінка□c418 - wait",
  "item.minecraft.music_disc_pigstep": "грампласцінка□ліна рэйн - pigstep",
  "item.minecraft.trident": "трызубец□□калі ў асноўнай руцэ:□+8 пашкоджанні□-2.9 хуткасць атакі",
  "item.minecraft.phantom_membrane": "фантомная мембрана",
  "item.minecraft.nautilus_shell": "ракавіна наўтылуса",
  "item.minecraft.heart_of_the_sea": "сэрца мора",
  "item.minecraft.crossbow": "самастрэл",
  "item.minecraft.suspicious_stew": "падазронае рагу",
  "block.minecraft.loom": "кросны",
  "item.minecraft.flower_banner_pattern": "узор для сцяга□кветка",
  "item.minecraft.creeper_banner_pattern": "узор для сцяга□твар крыпера",
  "item.minecraft.skull_banner_pattern": "узор для сцяга□чэрап",
  "item.minecraft.mojang_banner_pattern": "узор для сцяга□mojang",
  "item.minecraft.globe_banner_pattern": "узор для сцяга□глобус",
  "item.minecraft.piglin_banner_pattern": "узор для сцяга□лыч",
  "block.minecraft.composter": "кампоставая скрыня",
  "block.minecraft.barrel": "бочка",
  "block.minecraft.smoker": "вяндлярня",
  "block.minecraft.blast_furnace": "доменная печ",
  "block.minecraft.cartography_table": "варштат картографа",
  "block.minecraft.fletching_table": "варштат лучніка",
  "block.minecraft.grindstone": "шліфавальны круг",
  "block.minecraft.lectern": "аналой",
  "block.minecraft.smithing_table": "варштат каваля",
  "block.minecraft.stonecutter": "каменярэз",
  "block.minecraft.bell": "звон",
  "block.minecraft.lantern": "ліхтар",
  "block.minecraft.soul_lantern": "ліхтар душ",
  "item.minecraft.sweet_berries": "салодкія ягады",
  "block.minecraft.campfire": "вогнішча",
  "block.minecraft.soul_campfire": "вогнішча душ",
  "block.minecraft.shroomlight": "святлагрыб",
  "item.minecraft.honeycomb": "соты",
  "block.minecraft.bee_nest": "пчалінае гняздо",
  "block.minecraft.beehive": "вулей",
  "item.minecraft.honey_bottle": "пляшка мёду",
  "block.minecraft.honey_block": "блок мёду",
  "block.minecraft.honeycomb_block": "блок мядовых сотаў",
  "block.minecraft.lodestone": "магнетыт",
  "block.minecraft.netherite_block": "нэдарытавы блок",
  "block.minecraft.ancient_debris": "антычныя рэшткі",
  "block.minecraft.target": "мішэнь",
  "block.minecraft.crying_obsidian": "плакучы абсідыян",
  "block.minecraft.blackstone": "чарніт",
  "block.minecraft.blackstone_slab": "пліта з чарніту",
  "block.minecraft.blackstone_stairs": "прыступкі з чарніту",
  "block.minecraft.gilded_blackstone": "пазалочаны чарніт",
  "block.minecraft.polished_blackstone": "паліраваны чарніт",
  "block.minecraft.polished_blackstone_slab": "пліта з паліраванага чарніту",
  "block.minecraft.polished_blackstone_stairs": "прыступкі з паліраванага чарніту",
  "block.minecraft.chiseled_polished_blackstone": "разны паліраваны чарніт",
  "block.minecraft.polished_blackstone_bricks": "цэгла з паліраванага чарніту",
  "block.minecraft.polished_blackstone_brick_slab": "пліта з паліраванай чарнітавай цэглы",
  "block.minecraft.polished_blackstone_brick_stairs": "прыступкі з паліраванай чарнітавай цэглы",
  "block.minecraft.cracked_polished_blackstone_bricks": "патрэсканая цэгла з паліраванага чарніту",
  "block.minecraft.respawn_anchor": "котва адраджэння",
}
export const be_by = items; 
